import type { Config } from 'tailwindcss'

export const themeConfig = {
  screens: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px',
  },
}

export default {
  content: [],
  theme: {
    extend: themeConfig,
  },
} satisfies Config
